'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageLimit = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.processContact = processContact;
exports.processContacts = processContacts;
exports.getFilteredContacts = getFilteredContacts;
exports.getFilteredContactsPage = getFilteredContactsPage;

var _utils = require('helpers/utils');

var _strings = require('helpers/strings');

var _pagination = require('helpers/pagination');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filteredFields = ['name', 'surname', 'email'];

var pageLimit = exports.pageLimit = 100;

function processContact(contact) {
  var processedContact = (0, _extends3.default)({}, contact);
  processedContact.fullName = (0, _strings.concat)(' ', processedContact.name, processedContact.surname);
  return processedContact;
}

function processContacts(contacts) {
  return contacts.map(processContact);
}

function getFilteredContacts(_ref) {
  var contacts = _ref.contacts,
      kw = _ref.kw;

  return processContacts((0, _utils.filterObjectsByKws)({ objects: contacts, fields: filteredFields, kw: kw }));
}

function getFilteredContactsPage(_ref2) {
  var contacts = _ref2.contacts,
      kw = _ref2.kw,
      page = _ref2.page;

  var _getFromTo = (0, _pagination.getFromTo)({ page: page, limit: pageLimit }),
      from = _getFromTo.from,
      to = _getFromTo.to;

  var countAll = contacts.length;
  var filteredContacts = getFilteredContacts({ contacts: contacts, kw: kw });
  var filteredPageContacts = filteredContacts.slice(from, to);
  return {
    contacts: filteredPageContacts,
    count: filteredContacts.length,
    countAll: countAll
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/contacts.js
// module id = 868
// module chunks = 1